(() => {
  const UNIT_PRICE_SELECTOR = "span.yv-product-price.h2";
  const TOTAL_SELECTOR = "#wio-total-price";

  const QTY_INPUT_SELECTOR = "input[name='quantity'][type='number']";
  const QTY_UP_SELECTOR = ".quantity-button.quantity-up";
  const QTY_DOWN_SELECTOR = ".quantity-button.quantity-down";

  const DELAY = 80; // enough for theme to update input.value
  let timer;

  function debounce(fn) {
    clearTimeout(timer);
    timer = setTimeout(fn, DELAY);
  }

  function parseMoney(text) {
    if (!text) return null;
    const raw = String(text).trim();

    const symbol = (raw.match(/[^\d.,\s-]+/) || [""])[0];
    const numMatch = raw.match(/-?[\d.,]+/);
    if (!numMatch) return null;

    let numStr = numMatch[0];
    const hasDot = numStr.includes(".");
    const hasComma = numStr.includes(",");

    if (hasDot && hasComma) {
      if (numStr.lastIndexOf(",") > numStr.lastIndexOf(".")) {
        numStr = numStr.replace(/\./g, "").replace(",", ".");
      } else {
        numStr = numStr.replace(/,/g, "");
      }
    } else if (hasComma && !hasDot) {
      numStr = numStr.replace(",", ".");
    } else {
      numStr = numStr.replace(/,/g, "");
    }

    const value = Number(numStr);
    if (!Number.isFinite(value)) return null;

    return { symbol, pennies: Math.round(value * 100) };
  }

  function getQty() {
    const input = document.querySelector(QTY_INPUT_SELECTOR);
    if (!input) return 1;
    const v = parseInt(input.value || "1", 10);
    return Number.isFinite(v) && v > 0 ? v : 1;
  }

  function renderTotal() {
    const priceEl = document.querySelector(UNIT_PRICE_SELECTOR);
    const totalEl = document.querySelector(TOTAL_SELECTOR);
    if (!priceEl || !totalEl) return;

    const parsed = parseMoney(priceEl.textContent);
    if (!parsed) return;

    const qty = getQty();
    const totalPennies = parsed.pennies * qty;

    totalEl.textContent = `Total:  ${parsed.symbol}${(totalPennies / 100).toFixed(2)} for ${qty} pack(s) `;
  }

  function trigger() {
    debounce(renderTotal);
  }

  function init() {
    const qtyInput = document.querySelector(QTY_INPUT_SELECTOR);
    if (!qtyInput) return;

    // 1) Directly catch your theme’s +/- buttons
    document.addEventListener(
      "click",
      (e) => {
        if (e.target.closest(QTY_UP_SELECTOR) || e.target.closest(QTY_DOWN_SELECTOR)) {
          trigger();
        }
      },
      true
    );

    // 2) Normal typing in the input
    qtyInput.addEventListener("input", trigger);
    qtyInput.addEventListener("change", trigger);
    qtyInput.addEventListener("keyup", trigger);

    // 3) Catch silent programmatic updates to the input value (some themes do this)
    const mo = new MutationObserver(trigger);
    mo.observe(qtyInput, { attributes: true, attributeFilter: ["value"] });

    // 4) Initial
    trigger();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }

  // Theme editor section reload
  document.addEventListener("shopify:section:load", init);
})();
